import ArrowPoint from './ArrowPoint';

export default ArrowPoint;
